import { handleImgErrors } from "./modules/handleImgErrors";
import { getApiToken } from "./modules/tokenUtils";
import { formatFutureRelative } from "./modules/time-utils";
import { init, setTag, setContext, captureException } from "@sentry/browser";

init({
  dsn: "https://40e19bafa75d417ead2733a00ab3e30f@sentry.interpals.net/8",
  ignoreErrors: [
    "Non-Error exception captured",
    "Non-Error promise rejection captured"
  ]
});

setTag("user_id", window.userId ?? "none");

setContext("user", {
  id: window.userId ?? "none"
});

// Expose captureException for non-module scripts (e.g. adsense-init.js)
window.Sentry = { captureException };

handleImgErrors();

// Fetch api token on page load if not present in local storage
// document.addEventListener("DOMContentLoaded", async () => {
window.getApiToken = getApiToken;
window.formatFutureRelative = formatFutureRelative;
//   api.init(token);

  // Make api object available globally (for jquery)
  // window.api = api.methods;
// });

console.log("v:6");
